import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import userLogReadAction from './userLogRead.action.json' assert { type: 'json' }

const userLogReadDefinition = defineReadAutoAction(userLogReadAction, 'userLog')

export default userLogReadDefinition
